import { useDispatch, useSelector } from 'react-redux';
import { useDocumentationApiFacade } from '../../../apis/facades/useDocumentationApiFacade';
import {
  setMetadataTypes,
  selectMetadataTypes,
  setMetadataTypesLoading,
} from '../../../reducers/documentation/documentationPageReducer';
import { telemetry } from '../../../telemetry';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';

export const useInitializeMetadataTypes = () => {
  const dispatch = useDispatch();
  const { get_metadataTypes } = useDocumentationApiFacade();

  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const metadataTypesData = useSelector(selectMetadataTypes(crmOrgId ?? ''));
  const hasMetadataTypes = metadataTypesData?.types?.length > 0;
  const isLoading = metadataTypesData?.isLoading;
  const shouldFetch = !hasMetadataTypes && !isLoading;

  useRunOnceWhenTruthy(() => {
    if (!crmOrgId) {
      //check just for TS
      return;
    }

    const fetchMetadataTypes = async () => {
      dispatch(setMetadataTypesLoading({ isLoading: true, crmOrgId }));
      try {
        const metadataTypes = await get_metadataTypes();
        dispatch(setMetadataTypes({ types: metadataTypes, crmOrgId }));
      } catch (err) {
        telemetry.captureError(err);
        dispatch(setMetadataTypes({ types: [], crmOrgId }));
      }
    };

    fetchMetadataTypes();
  }, !!crmOrgId && shouldFetch);
};
